// 25HOURS GA4 enhanced events. Loaded with defer; gtag('config', G-NZVNW9YK4T) runs first.
(function () {
  'use strict';
  if (typeof window === 'undefined' || window.__ga4_25h_loaded) return;
  window.__ga4_25h_loaded = true;

  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
    } catch (e) {}
  }

  // 1) view_item_list — fires once per collection page render
  function fireViewItemList() {
    var d = window.collectionTrackingData;
    if (!d || !Array.isArray(d.items) || d.items.length === 0) return;
    track('view_item_list', {
      item_list_id: d.list_id,
      item_list_name: d.list_name,
      items: d.items.slice(0, 24)
    });
  }

  // 2) select_item — event delegation on [data-product-card]
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-product-card]');
    if (!card) return;
    var price = parseFloat(card.dataset.productPrice);
    track('select_item', {
      item_list_id: card.dataset.listId || '',
      item_list_name: card.dataset.listName || '',
      items: [{
        item_id: card.dataset.productId || '',
        item_name: card.dataset.productName || '',
        price: isNaN(price) ? undefined : price,
        index: parseInt(card.dataset.productIndex, 10) || 0
      }]
    });
  }, { passive: true, capture: true });

  // 3) scroll_milestone — 25/50/75/100
  (function () {
    var milestones = [25, 50, 75, 100];
    var fired = {};
    var queued = false;
    function check() {
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      if (docH <= 0) return;
      var pct = (window.scrollY / docH) * 100;
      for (var i = 0; i < milestones.length; i++) {
        var m = milestones[i];
        if (pct >= m && !fired[m]) {
          fired[m] = true;
          track('scroll_milestone', { percent: m, page_path: location.pathname });
        }
      }
    }
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; check(); });
    }, { passive: true });
  })();

  // 4) engagement_heartbeat — every 15s if visible + activity in last 15s
  (function () {
    var lastActivity = Date.now();
    var INTERVAL = 15000;
    var WINDOW = 15000;
    var beats = 0;
    function bump() { lastActivity = Date.now(); }
    ['mousemove', 'scroll', 'keydown', 'touchstart', 'touchmove', 'click'].forEach(function (ev) {
      window.addEventListener(ev, bump, { passive: true });
    });
    setInterval(function () {
      if (document.hidden) return;
      if (Date.now() - lastActivity > WINDOW) return;
      beats += 1;
      track('engagement_heartbeat', {
        engaged_seconds: beats * 15,
        page_path: location.pathname
      });
    }, INTERVAL);
  })();

  // 5) time_to_first_interaction
  (function () {
    var t0 = performance.now();
    var fired = false;
    function fire(kind) {
      if (fired) return;
      fired = true;
      track('time_to_first_interaction', {
        ms: Math.round(performance.now() - t0),
        kind: kind,
        page_path: location.pathname
      });
      window.removeEventListener('click', onClick, true);
      window.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('touchstart', onTouch, true);
      window.removeEventListener('keydown', onKey, true);
    }
    function onClick() { fire('click'); }
    function onScroll() { fire('scroll'); }
    function onTouch() { fire('touch'); }
    function onKey() { fire('key'); }
    window.addEventListener('click', onClick, { capture: true, passive: true });
    window.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('touchstart', onTouch, { capture: true, passive: true });
    window.addEventListener('keydown', onKey, { capture: true, passive: true });
  })();

  // 6) exit_intent — desktop only (mouse leaves via top edge)
  (function () {
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;
    var fired = false;
    document.addEventListener('mouseout', function (e) {
      if (fired) return;
      if (!e.relatedTarget && e.clientY < 10) {
        fired = true;
        track('exit_intent', {
          page_path: location.pathname,
          dwell_seconds: Math.round(performance.now() / 1000)
        });
      }
    }, { passive: true });
  })();

  // Robust bootstrap: cover all timing edge cases
  var __vil_fired = false;
  function safeFireViewItemList() {
    if (__vil_fired) return;
    var d = window.collectionTrackingData;
    if (!d || !Array.isArray(d.items) || d.items.length === 0) return;
    __vil_fired = true;
    fireViewItemList();
  }
  safeFireViewItemList();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeFireViewItemList);
  }
  window.addEventListener('load', safeFireViewItemList);

  // 7) Card swipe dots — active state follows scroll position via scrollLeft
  function initSwipeDots() {
    var wraps = document.querySelectorAll('.card__media-dots');
    if (!wraps.length) return;
    wraps.forEach(function (wrap) {
      var card = wrap.closest('.card.card--product') || wrap.closest('.card-wrapper');
      if (!card) return;
      var mediaContainer = card.querySelector('.media.media--hover-effect');
      if (!mediaContainer) return;
      var dots = wrap.querySelectorAll('.card__media-dot');
      if (dots.length < 2) return;

      var rafQueued = false;
      function update() {
        rafQueued = false;
        var w = mediaContainer.clientWidth;
        if (w <= 0) return;
        var idx = Math.round(mediaContainer.scrollLeft / w);
        if (idx < 0) idx = 0;
        if (idx >= dots.length) idx = dots.length - 1;
        dots.forEach(function (d, i) {
          if (i === idx) d.classList.add('card__media-dot--active');
          else d.classList.remove('card__media-dot--active');
        });
      }
      mediaContainer.addEventListener('scroll', function () {
        if (rafQueued) return;
        rafQueued = true;
        requestAnimationFrame(update);
      }, { passive: true });
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwipeDots);
  } else {
    initSwipeDots();
  }

  // 8) Popup tracking — view, submit, close, code copy
  function initPopupTracking() {
    var popup = document.querySelector('promo-popup');
    if (!popup) return;
    var pageType = (document.body.className.match(/template-(\w+)/) || [])[1] || 'unknown';

    // popup_view: fires when popup becomes visible (.hidden class removed)
    var viewFired = false;
    function firePopupView() {
      if (viewFired) return;
      if (popup.classList.contains('hidden')) return;
      viewFired = true;
      track('popup_view', { page_type: pageType, page_path: location.pathname });
    }
    new MutationObserver(firePopupView).observe(popup, { attributes: true, attributeFilter: ['class'] });
    firePopupView(); // case where it's already visible at script run

    // popup_email_submit: form submit
    var form = popup.querySelector('form.popup__newsletter');
    if (form) {
      form.addEventListener('submit', function () {
        var emailInput = form.querySelector('input[type="email"]');
        track('popup_email_submit', {
          page_type: pageType,
          email_provided: !!(emailInput && emailInput.value),
          page_path: location.pathname
        });
      }, { passive: true, capture: true });
    }

    // popup_close: close button click (or overlay click)
    var closers = popup.querySelectorAll('[data-popup-toggle]');
    closers.forEach(function (el) {
      el.addEventListener('click', function () {
        track('popup_close', {
          page_type: pageType,
          had_view: viewFired,
          page_path: location.pathname
        });
      }, { passive: true, capture: true });
    });

    // popup_code_copy: copy button on success state — also handles clipboard
    var copyBtn = popup.querySelector('[data-popup-copy-code]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var box = popup.querySelector('[data-popup-success]');
        var code = box && box.dataset.discountCode || 'NEW10OFF';
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () {
            copyBtn.classList.add('is-copied');
            setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 2000);
          }).catch(function () {});
        }
        track('popup_code_copy', { code: code, page_path: location.pathname });
      }, { passive: true, capture: true });
    }

    // popup_shop_click: clicking "Shop the collection" link in success state
    var shopLink = popup.querySelector('[data-popup-shop]');
    if (shopLink) {
      shopLink.addEventListener('click', function () {
        track('popup_shop_click', { page_path: location.pathname });
      }, { passive: true, capture: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopupTracking);
  } else {
    initPopupTracking();
  }
})();
